import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { MedicalImageViewOptions } from '@/shared/api/protocol-ts/model/dto_common_image_view_options_pb';

// Applies the CSS-expressible subset of instance-specific view settings to a
// rendered document image. Rotation/zoom/flip map to transform, and
// invert/brightness/contrast map to filter. DICOM-window/crop/pan settings are
// viewer-engine concepts and are intentionally not applied to a plain image.
export const imageViewTransform = (
  options?: MedicalImageViewOptions,
): string => {
  const rotation = options?.Rotation ?? 0;
  const zoom = options?.Zoom ?? 1;
  const flipX = options?.FlipHorizontal ? -1 : 1;
  return `rotate(${rotation}deg) scale(${flipX * zoom}, ${zoom})`;
};

export const imageViewFilter = (options?: MedicalImageViewOptions): string => {
  const filters: string[] = [];
  if (options?.Invert) filters.push('invert(1)');
  if (options?.Brightness != null && options.Brightness !== 1) {
    filters.push(`brightness(${options.Brightness})`);
  }
  if (options?.Contrast != null && options.Contrast !== 1) {
    filters.push(`contrast(${options.Contrast})`);
  }
  return filters.join(' ');
};

/**
 * Generated CBCT tooth slices store their pixels in a DICOM original file
 * that a plain <img> cannot decode; they render through the medical image
 * renderer instead (same as on the report page).
 */
export const isDicomSliceAsset = (asset: Asset) =>
  asset.Kind.case === 'GeneratedReport' &&
  (asset.Kind.value.Content.case === 'CBCTToothPathologySlice' ||
    asset.Kind.value.Content.case === 'CBCTGPToothSlice');
